<template>
  <section id="projetos">
    <div class="container">
      <title-vue title="Projetos" />
      <swiper
        :navigation="true"
        :modules="modules"
        :autoplay="{ delay: 3000, disableOnInteraction: false }"
        :breakpoints="{
          '300': {
            slidesPerView: 1,
            spaceBetween: 30,
          },
          '1000': {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          '1500': {
            slidesPerView: 4,
            spaceBetween: 50,
          },
        }"
      >
        <swiper-slide v-for="(item, index) in itensCard" :key="index"
          ><card-vue :card="item"
        /></swiper-slide>
      </swiper>
    </div>
  </section>
</template>

<script>
import TitleVue from "@/components/General/Title/Title.vue";
import CardVue from "@/components/Projects/Card.vue";

import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation, Autoplay } from "swiper";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
  name: "ProjectsView",
  setup() {
    const itensCard = [
      {
        projectLink: "https://countries-pink-nu.vercel.app/",
        projectPhoto: require("@/assets/icons/countries.svg"),
        alt: "Uma imagem da bandeira do Brasil",
        repositorieLink: "https://countries-pink-nu.vercel.app/",
        title: "Countries",
        stack: ["Vue 3", "Vue Router", "JavaScript"],
      },
      {
        projectLink: "https://todoapp-f2o.pages.dev/",
        projectPhoto: require("@/assets/icons/todoapp-f2o.pages.dev_.png"),
        alt: "Uma imagem da bandeira do Brasil",
        repositorieLink: "https://countries-pink-nu.vercel.app/",
        title: "Todo App",
        stack: ["Vue 3", "Vue Router", "JavaScript"],
      },
      {
        projectLink:
          "https://joaoquinto.github.io/natarajan/template/index.html",
        projectPhoto: require("@/assets/icons/natarajan.svg"),
        alt: "Uma imagem de uma mulher com roupa de piloto de caça, sentada na grama",
        repositorieLink: "https://github.com/joaoquinto/natarajan",
        title: "Natarajan",
        stack: ["HTML5", "CSS3", "JavaScript"],
      },
      {
        projectLink: "https://joaoquinto.github.io/getshape/",
        projectPhoto: require("@/assets/icons/getshape.svg"),
        alt: "Um imagem com uma mulher correndo",
        repositorieLink: "https://github.com/joaoquinto/getshape",
        title: "Getshape",
        stack: ["HTML5", "CSS3", "JavaScript"],
      },
      {
        projectLink: "https://joaoquinto.github.io/spacer/",
        projectPhoto: require("@/assets/icons/spacer.svg"),
        alt: "Uma imagem de uma pessoa em um espaço de coworking",
        repositorieLink: "https://github.com/joaoquinto/spacer",
        title: "Spacer",
        stack: ["HTML5", "CSS3", "Analytics"],
      },
      {
        projectLink: "https://joaoquinto.github.io/billie/index.html",
        projectPhoto: require("@/assets/icons/billie-eilish.svg"),
        alt: "Uma imagem da cantora Billie Eilish, com um filtro alaranjado",
        repositorieLink: "https://github.com/joaoquinto/billie",
        title: "Athena",
        stack: ["HTML5", "CSS3", "Analytics"],
      },
      {
        projectLink: "https://joaoquinto.github.io/card-frontend-mentor/",
        projectPhoto: require("@/assets/icons/column-preview.svg"),
        alt: "Uma imagem de três cards, cada um com um tipo de carro SEDAN, SUVS, Luxury",
        repositorieLink: "https://github.com/joaoquinto/card-frontend-mento",
        title: "3 column preview card",
        stack: ["HTML5", "CSS3", "Analytics"],
      },
      {
        projectLink: "https://joaoquinto.github.io/nft-card-componet/",
        projectPhoto: require("@/assets/icons/ntf-preview.svg"),
        alt: "Uma imagem de um cubo vermelho, com partes azuis.",
        repositorieLink: "https://github.com/joaoquinto/nft-card-componet",
        title: "NFT - Preview",
        stack: ["HTML5", "CSS3", "Analytics"],
      },
      {
        projectLink: "https://joaoquinto.github.io/summary-order/#",
        projectPhoto: require("@/assets/icons/order-summary.svg"),
        alt: "Uma imagem de um card de propaganda de uma plataforma de música.",
        repositorieLink: "https://github.com/joaoquinto/summary-order",
        title: "Order Summary",
        stack: ["HTML5", "CSS3", "Analytics"],
      },
      {
        projectLink: "https://joaoquinto.github.io/qr-code-component/",
        projectPhoto: require("@/assets/icons/card-component.svg"),
        alt: "Uma imagem de um QRcode azul que leva para a plataforma frontend mentor",
        repositorieLink: "https://github.com/joaoquinto/qr-code-component",
        title: "QR Card Component",
        stack: ["HTML5", "CSS3", "Analytics"],
      },
      {
        projectLink: "https://joaoquinto.github.io/johnathan-specter",
        projectPhoto: require("@/assets/icons/johnathan-specter.svg"),
        alt: "Uma UI de portfólio do programador Johnathan Specter",
        repositorieLink: "https://github.com/joaoquinto/johnathan-specter",
        title: "Johnathan Specter",
        stack: ["HTML5", "CSS3", "JavaScript"],
      },
      {
        projectLink: "https://joaoquinto.github.io/fylo/",
        projectPhoto: require("@/assets/icons/icon-fylo.svg"),
        alt: "Fylo é um desafio da plataforma frontendmentor",
        repositorieLink: "https://github.com/joaoquinto/fylo",
        title: "Fylo",
        stack: ["HTML5", "Stylus"],
      },
      {
        projectLink:
          "https://joaoquinto.github.io/sunnyside-agency-landing-page/",
        projectPhoto:
          "https://raw.githubusercontent.com/joaoquinto/sunnyside-agency-landing-page/main/assets/images/image-gallery-orange.jpg",
        alt: "Sunnyside é um desafio da plataforma frontendmentor",
        repositorieLink:
          "https://github.com/joaoquinto/sunnyside-agency-landing-page",
        title: "Sunnyside",
        stack: ["HTML5", "Stylus", "JavaScript"],
      },
      {
        projectLink: "https://joaoquinto.github.io/OMDB/",
        projectPhoto: require("@/assets/icons/omdb.png"),
        alt: "OMDB é uma API que retorna dados de filmes",
        repositorieLink: "https://github.com/joaoquinto/OMDB",
        title: "OMDB API",
        stack: ["HTML5", "Vue.js"],
      },
      {
        projectLink: "https://joaoquinto.github.io/finalSpace/index.html",
        projectPhoto:
          "https://finalspaceapi.com/api/character/avatar/mooncake.jpg",
        alt: "OMDB é uma API que retorna dados de filmes",
        repositorieLink: "https://github.com/joaoquinto/finalSpace",
        title: "Final Space API",
        stack: ["HTML5", "Vue.js"],
      },
    ];
    return { itensCard, modules: [Navigation, Autoplay] };
  },
  components: {
    TitleVue,
    CardVue,
    Swiper,
    SwiperSlide,
  },
};
</script>

<style scoped></style>
